import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatMenuTrigger, MatMenu, MatMenuContent } from '@angular/material/menu';
import { NgClass } from '@angular/common';
import { MatIconButton } from '@angular/material/button';

@Component({
    selector: 'app-static-column-note',
    templateUrl: './static-column-note.component.html',
    styleUrls: ['./static-column-note.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        MatIconButton,
        NgClass,
        MatMenuTrigger,
        MatIcon,
        MatMenu,
        MatMenuContent,
    ],
})
export class StaticColumnNoteComponent {

  @Input() columnName: string;
  @Input() columnNote: string;

  stickyNoteOpened: boolean = false;

}